import * as Types from '../../types.generated';

import { gql } from '@apollo/client';
import { CoverImageFragmentDoc, MediaFragmentDoc, TrainingResourceVersionFragmentDoc, ContentSharingPermissionFragmentDoc, TranslationSetFragmentDoc, ContentTagMembershipFragmentDoc, ImageUrlsFragmentDoc, AutomationFragmentDoc, ContentQrCodeFragmentDoc, AiGenerateModuleRequestFragmentDoc, UserSelectionFragmentDoc, PathInstanceThinFragmentDoc, RichTextDocumentFragmentDoc, ConvertMediaToRichTextDocumentWorkflowFragmentDoc, BlastSentRecordFragmentDoc, TrainingResourceFragmentDoc } from '../../fragments.generated';
export type PremiumLibraryItemUrl_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, premiumContentConfig: { __typename?: 'PremiumContentConfig', id: number, catalogPath?: { __typename?: 'CatalogPath', id: string, path: { __typename?: 'Path', id: number } } | null } } | null, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null };

export type ModuleOrPremiumContentLibraryItemTitle_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, premiumContentConfig: { __typename?: 'PremiumContentConfig', id: number, catalogPath?: { __typename?: 'CatalogPath', id: string, path: { __typename?: 'Path', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', en: string } } } } | null } } | null };

export type HasLibraryItemEditPermission_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, sharingPermissions: { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number } }> } };

export type LibraryItemOwner_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, createdBy?: { __typename?: 'Employee', id: number, name: string } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, createdBy?: { __typename?: 'Employee', id: number, name: string } | null } | null, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string, createdBy?: { __typename?: 'Employee', id: number, name: string } | null } | null };

export type LibraryItemUrlFragment = { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, path?: { __typename?: 'Path', id: number, publishedVersion?: { __typename?: 'PathVersion', id: string } | null, draftVersion: { __typename?: 'PathVersion', id: string } } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, premiumContentConfig: { __typename?: 'PremiumContentConfig', id: number, catalogPath?: { __typename?: 'CatalogPath', id: string, path: { __typename?: 'Path', id: number } } | null } } | null, course?: { __typename?: 'Course', id: number } | null, trainingResource?: { __typename?: 'TrainingResource', id: string } | null, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null, skill?: { __typename?: 'Skill', id: number } | null };

export type LibraryItemTitleFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, name: { __typename?: 'TranslationSet', en: string }, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', premiumContentConfig: { __typename?: 'PremiumContentConfig', catalogPath?: { __typename?: 'CatalogPath', path: { __typename?: 'Path', libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', en: string } } } } | null } } | null };

export type LibraryItemAvatarFragment = { __typename?: 'LibraryItem', id: string, type: Types.LibraryItemType, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null, trainingResource?: { __typename?: 'TrainingResource', id: string, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, workflow?: { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null, trainingResource: { __typename?: 'TrainingResource', id: string, lastBuilderActionId?: number | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null } } } | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, richTextDocument?: { __typename?: 'RichTextDocument', id: string, content: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } | null, media?: { __typename?: 'Media', id: number, loopVideo: boolean, hideVideoControls: boolean, unoptimizedUrl?: string | null, createdAt: string, updatedAt: string, thumbnailImageUrl?: string | null, mostRecentConvertMediaToRichTextDocumentWorkflow?: { __typename?: 'ConvertMediaToRichTextDocumentWorkflow', id: string, workflow?: { __typename?: 'WorkflowConnection', id: string, workflowNode?: { __typename?: 'WorkflowNode', id: string, failedAt?: string | null, succeededAt?: string | null } | null } | null, richTextDocuments?: Array<{ __typename?: 'RichTextDocument', id: string }> | null } | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null, trainingResourceVersions?: Array<{ __typename?: 'TrainingResourceVersion', id: string, trainingResource: { __typename?: 'TrainingResource', id: string, libraryItem: { __typename?: 'LibraryItem', id: string, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> } } } }> | null } | null, trainingResource: { __typename?: 'TrainingResource', id: string, lastBuilderActionId?: number | null, draftVersion: { __typename?: 'TrainingResourceVersion', id: string }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string } | null, libraryItem: { __typename?: 'LibraryItem', id: string, publishState?: Types.PublishState | null, name: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, description: { __typename?: 'TranslationSet', uuid: string, en: string, translationsDisabled?: boolean | null, translationOverrides: Array<{ __typename?: 'TranslationOverride', id: string, text: string, sourceText: string, language: Language }> }, qrCode?: { __typename?: 'ContentQRCode', id: string, includeLogo: boolean, includeTitle: boolean, isActive: boolean, imageUrl: string } | null } } } } | null, orgSharpConfig?: { __typename?: 'OrgSharpConfig', id: string } | null, orgPremiumContentConfig?: { __typename?: 'OrgPremiumContentConfig', id: number, premiumContentConfig: { __typename?: 'PremiumContentConfig', id: number, catalogPath?: { __typename?: 'CatalogPath', id: string, path: { __typename?: 'Path', id: number, libraryItem: { __typename?: 'LibraryItem', id: string, coverImage?: { __typename?: 'CoverImage', id: string, emojiIcon?: string | null, background?: Types.BackgroundGradient | null, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, wide?: string | null, medium?: string | null, thumb?: string | null } | null } | null } } } | null } } | null };

export type LibraryItemOwnerFragment = { __typename?: 'LibraryItem', createdBy?: { __typename?: 'Employee', id: number, name: string } | null };

export type LibraryUserSharingPermissionFragment = { __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number } };

export type LibraryContentSharingPermissionFragment = { __typename?: 'ContentSharingPermission', id: string, allAdmins: Types.SharingPermission, allManagers: Types.SharingPermission, individuals: Array<{ __typename?: 'UserSharingPermission', id: string, permission: Types.SharingPermission, user: { __typename?: 'Employee', id: number } }> };

export type TrainingResourceVersion__AvatarFragment = { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null };

export type TrainingResourceAvatar_LibraryItemFragment = { __typename?: 'LibraryItem', id: string, trainingResource?: { __typename?: 'TrainingResource', id: string, draftVersion: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null }, publishedVersion?: { __typename?: 'TrainingResourceVersion', id: string, type: Types.TrainingResourceVersionType, media?: { __typename?: 'Media', id: number, thumbnailImageUrl?: string | null, mediaUrls: { __typename?: 'TranslationSet', uuid: string, en: string }, imageUrls?: { __typename?: 'ImageUrls', id: string, original: string, thumb?: string | null } | null } | null } | null } | null };

export const PremiumLibraryItemUrl_LibraryItemFragmentDoc = gql`
    fragment PremiumLibraryItemUrl_LibraryItem on LibraryItem {
  id
  orgPremiumContentConfig {
    id
    premiumContentConfig {
      id
      catalogPath {
        id
        path {
          id
        }
      }
    }
  }
  orgSharpConfig {
    id
  }
}
    `;
export const ModuleOrPremiumContentLibraryItemTitle_LibraryItemFragmentDoc = gql`
    fragment ModuleOrPremiumContentLibraryItemTitle_LibraryItem on LibraryItem {
  id
  name {
    en
  }
  type
  orgSharpConfig {
    id
  }
  orgPremiumContentConfig {
    id
    premiumContentConfig {
      id
      catalogPath {
        id
        path {
          id
          libraryItem {
            id
            name {
              en
            }
          }
        }
      }
    }
  }
}
    `;
export const LibraryUserSharingPermissionFragmentDoc = gql`
    fragment LibraryUserSharingPermission on UserSharingPermission {
  id
  user {
    id
  }
  permission
}
    `;
export const LibraryContentSharingPermissionFragmentDoc = gql`
    fragment LibraryContentSharingPermission on ContentSharingPermission {
  id
  allAdmins
  allManagers
  individuals {
    ...LibraryUserSharingPermission
  }
}
    ${LibraryUserSharingPermissionFragmentDoc}`;
export const HasLibraryItemEditPermission_LibraryItemFragmentDoc = gql`
    fragment HasLibraryItemEditPermission_LibraryItem on LibraryItem {
  id
  sharingPermissions {
    ...LibraryContentSharingPermission
  }
}
    ${LibraryContentSharingPermissionFragmentDoc}`;
export const LibraryItemOwner_LibraryItemFragmentDoc = gql`
    fragment LibraryItemOwner_LibraryItem on LibraryItem {
  id
  createdBy {
    id
    name
  }
  orgPremiumContentConfig {
    id
    createdBy {
      id
      name
    }
  }
  orgSharpConfig {
    id
    createdBy {
      id
      name
    }
  }
}
    `;
export const LibraryItemUrlFragmentDoc = gql`
    fragment LibraryItemUrl on LibraryItem {
  id
  publishState
  path {
    id
    publishedVersion {
      id
    }
    draftVersion {
      id
    }
  }
  orgPremiumContentConfig {
    id
    premiumContentConfig {
      id
      catalogPath {
        id
        path {
          id
        }
      }
    }
  }
  course {
    id
  }
  trainingResource {
    id
  }
  orgSharpConfig {
    id
  }
  skill {
    id
  }
}
    `;
export const LibraryItemTitleFragmentDoc = gql`
    fragment LibraryItemTitle on LibraryItem {
  id
  name {
    en
  }
  type
  orgSharpConfig {
    id
  }
  orgPremiumContentConfig {
    premiumContentConfig {
      catalogPath {
        path {
          libraryItem {
            id
            name {
              en
            }
          }
        }
      }
    }
  }
}
    `;
export const LibraryItemAvatarFragmentDoc = gql`
    fragment LibraryItemAvatar on LibraryItem {
  id
  type
  coverImage {
    ...CoverImage
  }
  trainingResource {
    id
    publishedVersion {
      ...TrainingResourceVersion
    }
    draftVersion {
      ...TrainingResourceVersion
    }
  }
  orgSharpConfig {
    id
  }
  orgPremiumContentConfig {
    id
    premiumContentConfig {
      id
      catalogPath {
        id
        path {
          id
          libraryItem {
            id
            coverImage {
              ...CoverImage
            }
          }
        }
      }
    }
  }
}
    ${CoverImageFragmentDoc}
${TrainingResourceVersionFragmentDoc}`;
export const LibraryItemOwnerFragmentDoc = gql`
    fragment LibraryItemOwner on LibraryItem {
  createdBy {
    id
    name
  }
}
    `;
export const TrainingResourceVersion__AvatarFragmentDoc = gql`
    fragment TrainingResourceVersion__Avatar on TrainingResourceVersion {
  id
  type
  media {
    id
    thumbnailImageUrl
    mediaUrls {
      uuid
      en
    }
    imageUrls {
      id
      original
      thumb
    }
  }
}
    `;
export const TrainingResourceAvatar_LibraryItemFragmentDoc = gql`
    fragment TrainingResourceAvatar_LibraryItem on LibraryItem {
  id
  trainingResource {
    id
    draftVersion {
      ...TrainingResourceVersion__Avatar
    }
    publishedVersion {
      ...TrainingResourceVersion__Avatar
    }
  }
}
    ${TrainingResourceVersion__AvatarFragmentDoc}`;